import { IProductListPatchModel } from '@epicuro-next/data/lists';
import { ProductReference } from '@epicuro-next/models/engagement';

export const patchAddModel = (
  products: ProductReference[],
): IProductListPatchModel => {
  if (!products) return products;
  return {
    itemsToAdd: products.map((product) => ({
      productId: product.productId,
      brandId: product.brandId,
    })),
    itemsToDelete: [],
  };
};
